import { Check, ArrowDown } from "lucide-react";
import Reveal from "./Reveal";

const GUARANTEES = ["Solo 20 minutos", "Sin compromiso", "Sin venderte humo"];

export default function FinalCta() {
    return (
        <section className="relative overflow-hidden px-5 py-24 sm:py-32" data-testid="final-cta-section">
            <div className="pointer-events-none absolute left-1/2 top-1/2 h-[380px] w-[680px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#ff5c00]/[0.1] blur-[130px]" />
            <div className="relative mx-auto max-w-3xl text-center">
                <Reveal>
                    <h2 className="font-display text-3xl font-extrabold leading-[1.08] sm:text-5xl" data-testid="final-cta-headline">
                        ¿Vas a seguir viendo videos <em className="serif-accent text-grad">sin tomar acción?</em>
                    </h2>
                    <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-[#999] sm:text-base">
                        Imagínate cómo vas a estar en 6 meses si sigues exactamente igual que hoy. Agenda la consultoría — 20 minutos,
                        sin compromiso.
                    </p>
                </Reveal>

                <Reveal delay={150}>
                    <button
                        onClick={() => window.scrollToCalendar()}
                        className="btn-primary mt-10 px-8 py-4 text-sm sm:px-10 sm:text-base"
                        data-testid="final-cta-button"
                    >
                        Agendar mi consultoría con el equipo — Gratis
                        <ArrowDown className="h-4 w-4" />
                    </button>
                    <div className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-testid="micro-guarantees">
                        {GUARANTEES.map((g) => (
                            <span key={g} className="flex items-center gap-1.5 text-xs text-[#999] sm:text-sm">
                                <Check className="h-3.5 w-3.5 text-[#22c55e]" strokeWidth={3} />
                                {g}
                            </span>
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
